import { makeObservable, observable, computed, action } from 'mobx';
import { filter, head } from 'lodash';

import { getListaZemalja, getOtajstva, getZrna } from './KrunicaService';

class KrunicaStore {
  constructor() {
    makeObservable(this, {
      trenutniJezik: observable,
      trenutnaKrunica: observable,
      aktivniDan: observable,
      aktivnaZemlja: computed,
      aktivanTekstZrno: computed,
      getlistaJezika: computed,
      getlistaKrunica: computed,
      nazivdanTjedan: observable,
      getnazivdanTjedan: computed,
      dodajListaKrunica: action,
      prijevodOtajstva: action,
      prijevodOtajstvatext: observable,
      zrno: observable,
      naprijed: action,
      postaviListuJezika: action,
      nazad: action,
      aktivnoOtajstvo: observable,
      listaJezika: observable,
      listaKrunica: observable,
      promjeniJezik: action,
      promjeniNazivTjedna: action,
      promjeniAktivniDan: action,
      promjeniAktivnuKrunicu: action,
      promjeniListaKrunica: action,
      promjeniaktivnoOtajstvo: action,
    });
  }

  // inicijalne vrijednosti u app
  trenutniJezik = 'Hrvatski';
  trenutnaKrunica = 'gospa';
  aktivnoOtajstvo = '';
  listaOtajstva = [];
  listaZrnaRadno = [];
  listaJezika = [];
  listaKrunica = [];
  nazivdanTjedan = [];
  aktivniDan = '';
  prijevodOtajstvatext = null;
  zrno = -1;

  // povlačenje podataka aktivne zemlje
  get aktivnaZemlja() {
    const podaciZemlje = head(
      filter(getListaZemalja(), (data) => {
        return data.jezik === this.trenutniJezik;
      }),
    );
    // console.log('podaciZemlje', podaciZemlje);
    this.initPodataka(podaciZemlje);
    this.promjeniNazivTjedna(podaciZemlje);
    return podaciZemlje;
  }

  promjeniNazivTjedna = (podaciZemlje) => {
    this.nazivdanTjedan = podaciZemlje.daniTjedan;
  };

  //  inicijalizacija podataka
  initPodataka = (podaciZemlje) => {
    this.listaOtajstva = getOtajstva().map((data) => {
      return {
        ...data,
        text: podaciZemlje[data.id],
      };
    });

    this.listaZrnaRadno = getZrna().map((data) => {
      return {
        ...data,
        text: podaciZemlje[data.id],
      };
    });

    // postavi dan u tjednu i aktivno otajstvo
    const d = new Date();
    switch (d.getDay()) {
      case 0:
        this.promjeniAktivniDan('ned');
        this.promjeniaktivnoOtajstvo('otajstvoSlavno');
        break;
      case 1:
        this.promjeniAktivniDan('pon');
        this.promjeniaktivnoOtajstvo('otajstvoRadosna');
        break;
      case 2:
        this.promjeniAktivniDan('uto');
        this.promjeniaktivnoOtajstvo('otajstvoZalosno');
        break;
      case 3:
        this.promjeniAktivniDan('sri');
        this.promjeniaktivnoOtajstvo('otajstvoSlavno');
        break;
      case 4:
        this.promjeniAktivniDan('cet');
        this.promjeniaktivnoOtajstvo('otajstvoSvjetla');
        break;
      case 5:
        this.promjeniAktivniDan('pet');
        this.promjeniaktivnoOtajstvo('otajstvoZalosno');
        break;
      case 6:
        this.promjeniAktivniDan('sub');
        this.promjeniaktivnoOtajstvo('otajstvoRadosna');
        break;
      default:
    }
    this.postaviListuJezika();
    this.prijevodOtajstva();
    this.postaviListuKrunica();
  };

  // povlačimo listu jezika
  get getlistaJezika() {
    return this.listaJezika;
  }

  // povlačimo listu jezika
  get getlistaKrunica() {
    return this.listaKrunica;
  }

  // poziva dane u tjednu
  get getnazivdanTjedan() {
    return this.nazivdanTjedan;
  }

  // vracamo na pocetak
  povratakNaPocetak = () => {
    this.zrno = -1;
  };

  // promjeni datum u tjednu
  promjeniDanUTjednu = (e) => {
    this.promjeniAktivniDan(e.target.value);
    if (this.aktivniDan === 'pon' || this.aktivniDan === 'sub') {
      this.promjeniaktivnoOtajstvo('otajstvoRadosna');
    }
    if (this.aktivniDan === 'uto' || this.aktivniDan === 'pet') {
      this.promjeniaktivnoOtajstvo('otajstvoZalosno');
    }
    if (this.aktivniDan === 'sri' || this.aktivniDan === 'ned') {
      this.promjeniaktivnoOtajstvo('otajstvoSlavno');
    }
    if (this.aktivniDan === 'cet') {
      this.promjeniaktivnoOtajstvo('otajstvoSvjetla');
    }
    this.prijevodOtajstva();
  };

  idiNaZrno = (zrno) => {
    this.zrno = zrno.target.value;
  };

  // action promjeni aktivni dan
  promjeniAktivniDan = (data) => {
    this.aktivniDan = data;
  };

  // action promjeni listu krunica
  promjeniAktivnuKrunicu = (data) => {
    this.trenutnaKrunica = data;
    this.zrno = -1;
  };

  // action promjeni listu krunica
  promjeniListaKrunica = () => {
    this.listaKrunica.replace([]);
  };

  // action dodaj listu krunica
  dodajListaKrunica = (element) => {
    this.listaKrunica.push(element);
  };

  promjeniaktivnoOtajstvo = (otajstvo) => {
    this.aktivnoOtajstvo = otajstvo;
  };

  postaviListuJezika = () => {
    this.listaJezika = getListaZemalja().map((data) => {
      return { label: data.idJezik, value: data.jezik };
    });
  };

  postaviListuKrunica = () => {
    this.promjeniListaKrunica();
    getListaZemalja().map((data) => {
      if (data.jezik === this.trenutniJezik) {
        for (let element of data.krunice) {
          this.dodajListaKrunica(element);
        }
      }
      return null;
    });
  };

  // prevodi OTAJSTVO
  prijevodOtajstva() {
    this.listaOtajstva.forEach((data) => {
      if (data.id === this.aktivnoOtajstvo) {
        this.prijevodOtajstvatext = data.text;
      }
    });
  }

  // pronalazi text vrijednost
  get aktivanTekstZrno() {
    let podatak;
    for (const [key, value] of Object.entries(this.aktivnaZemlja)) {
      if (key === `text${this.zrno}`) {
        podatak = `${value}`;
      }
    }
    return podatak;
  }

  // mijenja zrno unaprijed
  naprijed = () => {
    if (this.zrno === 61) {
      return;
    }
    this.zrno++;
  };

  // mijenja zrno unazad
  nazad = () => {
    if (this.zrno === -1) {
      return;
    }
    this.zrno--;
  };

  // promjena jezika
  promjeniJezik = (e) => {
    this.trenutniJezik = e.target.value;
    this.prijevodOtajstva();
    if (this.aktivniDan === 'pon' || this.aktivniDan === 'sub') {
      this.aktivnoOtajstvo = 'otajstvoRadosna';
    }
    if (this.aktivniDan === 'uto' || this.aktivniDan === 'pet') {
      this.aktivnoOtajstvo = 'otajstvoZalosno';
    }
    if (this.aktivniDan === 'sri' || this.aktivniDan === 'ned') {
      this.aktivnoOtajstvo = 'otajstvoSlavno';
    }
    if (this.aktivniDan === 'cet') {
      this.aktivnoOtajstvo = 'otajstvoSvjetla';
    }
  };

  // promjeni Krunicu
  promjeniKrunicu = (e) => {
    this.promjeniAktivnuKrunicu(e.target.value);
    if (this.zrno === 61 && this.trenutnaKrunica === 'rita') {
      this.nazad();
    }
  };
}

export const storeKrunica = new KrunicaStore();
